import React, { useCallback, useEffect, useRef, useState } from "react";

import {
    Content,
    ContentBody,
    DialogContainer,
    DialogTop,
    DialogTopLeft,
    DialogTopCenter,
    DialogTopRight,
    DialogFooter,
    BtnInsertNewAnswer,
    ContainerForm
} from "../NewPanel/style";

import { AiOutlineClose } from "react-icons/ai";
import { FieldProps, Fields } from "../../Forms/Fields/FieldBuilder";
import { FormHandles } from "@unform/core";
import FormBuilder from "../../Forms/FormBuilder";

import { Panel } from "../../../interfaces/Panel";
import { useToast } from "../../../hooks/toast";
import api from "../../../services/api";
import DialogAction from "../../../dialogs/DialogAction";

const fieldsPanelForm: FieldProps[] = [
    {
        name: "name_panel",
        type: Fields.CUSTOM_SELECT_FIELD,
        required: true,
        variation: "1",
        max_length: 50,
        index: 0,
        title: "Nome do painel",
        description: "Digite o nome do painel",
        placeholder: "Digite aqui...",
        help_text: "Neste campo é ideal que você escolha um nome claro para o seu painel, pois este nome que será exibido dentro do Cange para identifica-lo",
        validation_type: "string",
        validations: [
            {
                type: "required",
                params: ["O campo Nome do Painel é obrigatório!"]
            },
            {
                type: "min",
                params: [2, "O campo Nome deve conter mais de 2 letras!"]
            }
        ]
    }
];

interface panelProps {
    name_panel: string;
}

interface EditPanelProps {
    open: boolean;
    panel: Panel;
    onClose: (withRefresh?: boolean, selectId?: number) => void;
}

const EditPanel: React.FC<EditPanelProps> = ({ open, panel, onClose }) => {

    const { addToast } = useToast();

    const formRefPanel = useRef<FormHandles>(null);

    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [loadingDelete, setLoadingDelete] = useState<boolean>(false);
    const [stateDelPanel, setStateDelPanel] = useState<boolean>(false);

    const handleClose = useCallback(async () => {
        onClose();
    }, [onClose]);

    const handleSubmitForm = useCallback(async (data: object[]) => {

        if (data !== undefined) {

            const dataNormalized = data as unknown as panelProps;

            if (dataNormalized !== undefined && dataNormalized.name_panel !== "") {

                setLoadingSave(true);

                const body: Panel = {
                    ...panel,
                    name: dataNormalized.name_panel                    
                };

                await api
                    .post('/panel', body)
                    .then(response => {

                        const panelApi: Panel = response.data;

                        if (panelApi !== undefined && panelApi.id_panel !== undefined && panelApi.id_panel > 0) {

                            setLoadingSave(false);
                            addToast({
                                type: 'success',
                                title: 'Painel atualizado com sucesso!',
                                description: `O painel ${panelApi.name} foi atualizado com sucesso!`,
                            });

                            onClose(true, panelApi.id_panel);

                        } else {
                            setLoadingSave(false);
                            addToast({
                                type: 'error',
                                title: 'Erro ao atualizar o painel',
                                description: 'Ocorreu um erro ao tentar atualizar o painel! Tente novamente mais tarde.',
                            });
                        }

                    }).catch(error => {
                        setLoadingSave(false);
                        console.log(error);
                        addToast({
                            type: 'error',
                            title: 'Erro ao atualizar o painel',
                            description: 'Ocorreu um erro ao tentar atualizar o painel! Tente novamente mais tarde.',
                        });
                    });

            } else {
                addToast({
                    type: 'error',
                    title: 'Erro ao atualizar o painel',
                    description: 'O nome do painel é obrigatório! Por favor, preencha o campo Nome corretamente.',
                });
            }

        }

    }, [addToast, panel, onClose]);

    const handleSubmitPage = useCallback(async () => {
        if (formRefPanel.current !== undefined) {
            formRefPanel.current?.submitForm();
        }
    }, []);

    const dialogDelPanelSubmmit = useCallback(async () => {
        setLoadingDelete(true);

        await api.delete('/panel', {
            params: {
                id_panel: panel.id_panel,
                flow_id: panel.flow_id
            }
        }).then(response => {
            setLoadingDelete(false);
            addToast({
                type: 'success',
                title: 'Painel excluído com sucesso!',
                description: `O painel ${panel.name} foi excluído com sucesso!`,
            });

            onClose(true);
        }).catch(error => {
            setLoadingDelete(false);
            console.log(error);
            addToast({
                type: 'error',
                title: 'Erro ao excluir o painel',
                description: 'Ocorreu um erro ao tentar excluir o painel! Tente novamente mais tarde.',
            });
        });
    }, [addToast, onClose, panel]);

    const handleDelete = useCallback(() => {
        setStateDelPanel(true);
    }, []);

    //Focus on input when open
    useEffect(() => {
        if (open) {
            setTimeout(() => {
                const input = document.querySelector<HTMLInputElement>('input[name="name_panel"]');
                if (input) {
                    input.focus();
                }
            }, 150);
        }
    }, [open]);

    //Keyboard Shortcuts
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
                handleSubmitPage();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleSubmitPage]);

    return (
        <DialogContainer
            fullWidth={true}
            maxWidth="sm"
            open={open}
            onClose={handleClose}
        >
            <DialogTop>
                <DialogTopLeft>
                    <h1>{"Editar painel"}</h1>
                </DialogTopLeft>

                <DialogTopCenter />

                <DialogTopRight>
                    <button onClick={handleClose}><AiOutlineClose /></button>
                </DialogTopRight>
            </DialogTop>
            <Content>
                <ContentBody container>
                    <ContainerForm>
                        <FormBuilder
                            id="formEditPanel"
                            formRef={formRefPanel}
                            fields={fieldsPanelForm}
                            handleSubmit={handleSubmitForm}
                            hideContainer={true}
                            initialValue={{ name_panel: panel.name }}
                        />
                    </ContainerForm>
                </ContentBody>
            </Content>
            <DialogFooter style={{ display: 'flex', justifyContent: 'space-between' }}>
                <BtnInsertNewAnswer color="#f23b5c" style={{ width: '100px', height: '36px' }} onClick={handleDelete}>
                    Excluir
                </BtnInsertNewAnswer>
                <BtnInsertNewAnswer color="#9337ed" style={{ width: '130px', height: '36px' }} onClick={handleSubmitPage} isLoading={loadingSave}>
                    Salvar
                </BtnInsertNewAnswer>
            </DialogFooter>

            {/* Dialog de confirmação de exclusão */}
            <DialogAction
                open={stateDelPanel}
                message={"Você tem certeza que deseja excluir este Painel?"}
                actions_items={[
                    "Exclusão do painel em todos os fluxos de visualização;",
                    "Exclusão permanente de todas as informações do painel;"
                ]}
                disclaimer={"Lembrando que após a confirmação não será mais possível recuperar os dados referentes a este Painel!"}
                onSubmmit={dialogDelPanelSubmmit}
                onClose={() => setStateDelPanel(false)}
                type={1}
                isLoading={loadingDelete}
            />
        </DialogContainer>
    );
};

export default EditPanel; 